<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_planet_build_ships', router)
}

const isOnPlanetsSection = computed(() => {
  return route.path.startsWith('/planets')
})

const goToPlanets = () => {
  router.push('/planets')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/planet.webm"
  >
    <template #text>
      <p class="pb-2">
        Now let's build some colony ships to expand your empire!
      </p>
      <p class="pb-2">
       Ship construction requires production <GenericIcon type="production" /> and time, just like buildings.
      </p>
      <p class="pb-2">
        Any planet can build any ship design, keep that in mind.
      </p>
      <p class="pb-2">
        For now, let's build more colonizers to settle the available planets in your solar system.
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="mb-2">
        <p class="pb-2">
          Click on the "Production" tab and then on the <GenericIcon type="production" /> button.
          Then click on build icon on the "Ship" card.
          A popup will appear, simply select which ship design you wish to build a ship for.
        </p>
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnPlanetsSection" @click="goToPlanets" class="mr-2">
        Go to Planets
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Got it!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>